import {IProgramClassDetailsState} from './IProgramClassDetailsState';

export const programClassDetailsInitialState: IProgramClassDetailsState = {
  loading: false,
};
